<h2 mat-dialog-title>New Patient Tracker Lookup</h2>
<mat-dialog-content>
  <form (submit)="search()" novalidate>
    <mat-form-field>
      <input matInput name="StartDate" [matDatepicker]="startDatePicker" placeholder="Start Date" [(ngModel)]="StartDate" required>
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <input matInput name="EndDate" [matDatepicker]="endDatePicker" placeholder="End Date" [(ngModel)]="EndDate" required>
      <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>
    <button mat-flat-button color="primary"><mat-icon>search</mat-icon></button>
  </form>

  @if (trackTable) {
    <mat-card appearance="outlined" class="table-card">
      <app-new-patient-tracker-table [table]="trackTable" [noShowStatusIds]="noShowStatusIds" [treatmentStatuses]="treatmentStatuses" [remoteTargets]="remoteTargets | async">
      </app-new-patient-tracker-table>
    </mat-card>
  }

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
